export const SET_MEDIA_ASSETS_PROCESSING = 'SET_MEDIA_ASSETS_PROCESSING'
export const SET_MEDIA_ASSETS_PROCESSING_INFO = 'SET_MEDIA_ASSETS_PROCESSING_INFO'
export const RESET_MEDIA_ASSETS_DATA = 'RESET_MEDIA_ASSETS_DATA'
export const SET_MEDIA_ASSETS_DATA_ASSET = 'SET_MEDIA_ASSETS_DATA_ASSET'
export const SET_MEDIA_ASSETS_DATA_ASSET_PROCESSING = 'SET_MEDIA_ASSETS_DATA_ASSET_PROCESSING'
export const GET_MEDIA_ASSETS_DATA_ASSET = 'GET_MEDIA_ASSETS_DATA_ASSET'
export const PUBLISH_MEDIA_ASSETS_DATA = 'PUBLISH_MEDIA_ASSETS_DATA'
export const PUBLISH_MEDIA_ASSETS_DATA_ASSET = 'PUBLISH_MEDIA_ASSETS_DATA_ASSET'
export const UNPUBLISH_MEDIA_ASSETS_DATA_ASSET = 'UNPUBLISH_MEDIA_ASSETS_DATA_ASSET'
export const SET_MEDIA_ASSETS_BY_CONTENT_ID = 'SET_MEDIA_ASSETS_BY_CONTENT_ID'
export const SET_MEDIA_ASSETS_BY_CONTENT_ID_ERROR = 'SET_MEDIA_ASSETS_BY_CONTENT_ID_ERROR'
export const RESET_MEDIA_ASSETS_MESSAGES = 'RESET_MEDIA_ASSETS_MESSAGES'
export const SET_MEDIA_ASSETS_MESSAGE = 'SET_MEDIA_ASSETS_MESSAGE'
export const GET_MEDIA_ASSET_BY_ID = 'GET_MEDIA_ASSET_BY_ID'

export const GET_MEDIA_ASSET_LIST = 'GET_MEDIA_ASSET_LIST'
export const SET_MEDIA_ASSET_LIST = 'SET_MEDIA_ASSET_LIST'
export const SET_MEDIA_ASSET_LIST_OFFSET_LIMIT = 'SET_MEDIA_ASSET_LIST_OFFSET_LIMIT'
export const SET_MEDIA_ASSET_ERROR = 'SET_MEDIA_ASSET_ERROR'
export const CLEAR_MEDIA_ASSET_ERROR = 'CLEAR_MEDIA_ASSET_ERROR'

export function getMediaAssetList ({
  storeKey, offset, limit, processing = true,
}) {
  return {
    type: GET_MEDIA_ASSET_LIST,
    payload: {
      storeKey, offset, limit, processing,
    },
  }
}

export function setMediaAssetList ({
  storeKey, data, total, processing = false,
}) {
  return {
    type: SET_MEDIA_ASSET_LIST,
    payload: {
      storeKey, data, total, processing,
    },
  }
}

export function setMediaAssetListOffsetLimit ({
  storeKey, offset, limit, processing = true,
}) {
  return {
    type: SET_MEDIA_ASSET_LIST_OFFSET_LIMIT,
    payload: {
      storeKey, offset, limit, processing,
    },
  }
}

export function setMediaAssetError (err) {
  return {
    type: SET_MEDIA_ASSET_ERROR,
    payload: { err },
  }
}

export function clearMediaAssetError () {
  return {
    type: CLEAR_MEDIA_ASSET_ERROR,
    payload: {},
  }
}

export function setMediaAssetsProcessing ({ storeKey, processing = true }) {
  return {
    type: SET_MEDIA_ASSETS_PROCESSING,
    payload: { storeKey, processing },
  }
}

export function setMediaAssetsProcessingInfo ({ storeKey, info }) {
  return {
    type: SET_MEDIA_ASSETS_PROCESSING_INFO,
    payload: { storeKey, info },
  }
}

export function resetMediaAssetsMessages ({ storeKey }) {
  return {
    type: RESET_MEDIA_ASSETS_MESSAGES,
    payload: { storeKey },
  }
}

export function getMediaAssetById ({ storeKey, id }) {
  return {
    type: GET_MEDIA_ASSET_BY_ID,
    payload: { storeKey, id },
  }
}

export function setMediaAssetsMessage ({ storeKey, message, index }) {
  return {
    type: SET_MEDIA_ASSETS_MESSAGE,
    payload: { storeKey, message, index },
  }
}

export function resetMediaAssetsData ({ storeKey }) {
  return {
    type: RESET_MEDIA_ASSETS_DATA,
    payload: { storeKey },
  }
}

/**
 * Sets the image Map on the data list
 * @param {Object} params The params
 * @param {import('immutable').Map} params.asset The asset
 * @param {String} params.storeKey The branch of the store to modify
 * @param {Boolean} params.index The data intem index
 */
export function setMediaAssetsDataAsset ({ asset, storeKey, index } = {}) {
  return {
    type: SET_MEDIA_ASSETS_DATA_ASSET,
    payload: { asset, storeKey, index },
  }
}

/**
 * Sets the processing property on an image Map
 * @param {Object} params The params
 * @param {Boolean} params.processing The value of the processing property
 * @param {String} params.storeKey The branch of the store to modify
 * @param {Boolean} params.index The data intem index
 */
export function setMediaAssetsDataAssetProcessing ({ processing, storeKey, index } = {}) {
  return {
    type: SET_MEDIA_ASSETS_DATA_ASSET_PROCESSING,
    payload: { processing, storeKey, index },
  }
}

export function getMediaAssetsDataAsset ({ asset, storeKey, index }) {
  return {
    type: GET_MEDIA_ASSETS_DATA_ASSET,
    payload: { asset, storeKey, index },
  }
}

export function publishMediaAssetsData ({ storeKey, data }) {
  return {
    type: PUBLISH_MEDIA_ASSETS_DATA,
    payload: { storeKey, data },
  }
}

export function publishMediaAssetsDataAsset ({ asset, storeKey, index }) {
  return {
    type: PUBLISH_MEDIA_ASSETS_DATA_ASSET,
    payload: { asset, storeKey, index },
  }
}

export function unpublishMediaAssetsDataAsset ({ asset, storeKey, index }) {
  return {
    type: UNPUBLISH_MEDIA_ASSETS_DATA_ASSET,
    payload: { asset, storeKey, index },
  }
}

export function setMediaAssetsByContentId ({ storeKey, data }) {
  return {
    type: SET_MEDIA_ASSETS_BY_CONTENT_ID,
    payload: { storeKey, data },
  }
}

export function setMediaAssetsByContentIdError ({ storeKey, error }) {
  return {
    type: SET_MEDIA_ASSETS_BY_CONTENT_ID_ERROR,
    payload: { storeKey, error },
  }
}
